export interface IGetPackageHistoryTopUpResponse {
  totalElements: number;
  totalPages: number;
  pageable: IPageable;
  content: IHistoryTopUpContent[];
}

export interface IPageable {
  sort: Sort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  unpaged: boolean;
  paged: boolean;
}

export interface Sort {
  sorted: boolean;
  empty: boolean;
  unsorted: boolean;
}

export interface IHistoryTopUpContent {
  id: string;
  createdDate: string;
  amount: number;
  note: string | null;
  type: string;
  approvedDate: string;
  paidDate: string;
}

export interface IGetPackageSmsDashboardResponse {
  smsPrice: number;
  voicePrice: number;
  autoExtendAmount: boolean;
  amountExtend: number;
  autoApprovedPurchase: boolean;
  summary: {
    totalAmount: number;
    totalSms: number;
    costSms: number;
    totalVoice: number;
    costVoice: number;
    balance: number;
  };
}

export interface IUpdatePackageSMSBody {
  smsPrice: number;
  voicePrice: number;
  autoExtendAmount: boolean;
  amountExtend: number;
  autoApprovedPurchase: boolean;
}

export interface ICreateTopUpAmountBody {
  amount: number;
  note: string;
}

export enum SMS_PACKAGE_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  PAID = 'PAID',
}

export const SMS_PACKAGE_STATUS_META: Record<SMS_PACKAGE_STATUS,{ label: string; backgroundColor: string; color: string;}> = {
  [SMS_PACKAGE_STATUS.PENDING]: {
    label: 'Pending',
    backgroundColor: '#FFEAF6',
    color: '#F53F3F',
  },

  [SMS_PACKAGE_STATUS.APPROVED]: {
    label: 'Approved',
    backgroundColor: '#DBEFFF',
    color: '#2563EB',
  },

  [SMS_PACKAGE_STATUS.CANCELED]: {
    label: 'Canceled',
    backgroundColor: '#CBD5E1',
    color: '#1D2129',
  },

  [SMS_PACKAGE_STATUS.PAID]: {
    label: 'Paid',
    backgroundColor: '#ECFDF8',
    color: '#0DA472',
  },
};

export type IUpdateStatusTopUpBody = {
  id: string;
  status: string;
  note?: string;
};

export interface IUpdateTopUpAmountBody {
  id: string;
  status?: string;
  note?: string;
  amount: number;
}